import { COUPON_OPEN_DETAILS } from '../actionTypes/CouponListActionTypes';

// payload defaults to false (modal closed), and can be a integer (trigger at which coupon slot)
const openDetailsModal = (payload) => ({
    type: COUPON_OPEN_DETAILS,
    payload,
});

export default {
    openDetailsModal,
};
